import React from "react";
import themeLarge from "../ThemeLarge";
import ideas from "../../static/ideas.avif";

class GetToKnowMe extends React.Component {
  render() {
    return (
      <div
        style={{
          paddingTop: "40px",
          paddingBottom: "40px",
          background: themeLarge.colors.bg,
        }}
      >
        <div className="container">
          {/* Title */}
          <p
            className="d-flex justify-content-center"
            style={{
              color: themeLarge.colors.text,
              fontSize: themeLarge.fontSize.h2,
              fontFamily: "Kumbh Sans",
            }}
          >
            Get To Know Me
          </p>

          {/* One-liner */}
          <h3
            className="d-flex justify-content-center text-center"
            style={{
              color: "#000",
              fontSize: themeLarge.fontSize.body,
              fontFamily: "Kumbh Sans",
              margin: "0 auto",
              paddingTop: "10px",
            }}
          >
            I like building thoughtful things with curious people.
          </h3>

          {/* Keywords */}
          <div
            className="d-flex justify-content-center flex-wrap mt-4"
            style={{ gap: "10px" }}
          >
            {[
              "🎓 MSc in InfoSec (Tampere)",
              "🧠 Full-Stack @ Superwider",
              "🧘 Calm Tech Fan",
              "📊 Data Storyteller",
              "🌏 Art Curious",
              "✍️ Blogs & Reflections",
              "👓 XR Experiments",
            ].map((tag, index) => (
              <span
                key={index}
                className="badge"
                style={{
                  fontSize: themeLarge.fontSize.body,
                  padding: "8px 16px",
                  borderRadius: "20px",
                  background: themeLarge.colors.primary,
                  fontFamily: "Kumbh Sans",
                  fontWeight: "400",
                }}
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="row">
            <div className="col-md-6">
              {/* left */}

              {/* Timeline */}
              {/* <div className="mt-5" style={{ fontFamily: "Kumbh Sans" }}>
                <h5 style={{ fontWeight: "bold" }}>Timeline Highlights</h5>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>2022</strong>: Began MSc (Tech) in Information
                    Security at Tampere University, with a minor in
                    Human-Technology Interaction. Launched first version of{" "}
                    <a
                      href="https://ibtehaz.xyz"
                      target="_blank"
                      rel="noreferrer"
                    >
                      ibtehaz.xyz
                    </a>
                    .
                  </li>
                  <li>
                    <strong>2023</strong>: Completed summer internship at HUBS,
                    exploring entrepreneurship and innovation.
                  </li>
                  <li>
                    <strong
                      style={{
                        fontSize: themeLarge.fontSize.h4,
                      }}
                    >
                      2024
                    </strong>{" "}
                    -
                    <span
                      style={{
                        color: themeLarge.colors.primary,
                        fontWeight: "700",
                        marginLeft: "10px",
                        fontSize: themeLarge.fontSize.h3,
                      }}
                    >
                      A Year of Exploration:
                    </span>
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                      <li>
                        ECIU Challenge (Lithuania, Feb–June) with KTU & LitGrid:
                        Hands-on energy sector project
                      </li>
                      <li>
                        Summer semester at University of Giessen: Studied open
                        data, climate models, Byzantine art, peacebuilding, and
                        human rights
                      </li>
                      <li>
                        Sprint Innovation Festival at HUBS (March) + GEM
                        Workshop (May) → Designed a data viz from receipts found
                        in trash
                      </li>
                      <li>
                        Joined OASIS as Research Assistant: Co-authored a
                        conference paper, working on a journal paper
                      </li>
                      <li>
                        Completed <em>Google Data Analytics</em> (July) &{" "}
                        <em>Intro to Data Science with Python</em> (Aug)
                      </li>
                      <li>
                        Prototyping seminars, DigitAInability Winter School,
                        3-day 3D design workshop at TUNI
                      </li>
                      <li>
                        Started Asian Studies minor at University of Turku —
                        courses on Mongolia and Chinese history
                      </li>
                      <li>
                        Started revamp of{" "}
                        <a
                          href="https://ibtehaz.xyz"
                          target="_blank"
                          rel="noreferrer"
                        >
                          ibtehaz.xyz
                        </a>{" "}
                        (Sept)
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>2025</strong>: Building and shipping:
                    <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                      <li>
                        <strong>MetaPriv</strong> — my thesis: a privacy tool
                        for Facebook (Jan–Jul) under Prof. Antonios Michalas
                      </li>
                      <li>
                        Demola Summer Internship (May–Jul): Co-created event
                        experience solutions for live events
                      </li>
                      <li>
                        Superwider Internship (May–ongoing): Working part-time
                        as a full-stack developer (Next.js / TypeScript)
                      </li>
                      <li>
                        Platform6 Challenge at Make it Better Digithon: Designed
                        solutions for member retention (Feb)
                      </li>
                      <li>
                        ECIU Hackathon (Feb): Built <strong>OLA</strong> – an AI
                        agent with ChatGPT to guide students in ECIU
                        opportunities
                      </li>
                    </ul>
                  </li>
                </ul>
              </div> */}

              {/* Now Section */}
              <div className="mt-4">
                <h5 style={{ fontFamily: "Kumbh Sans", fontWeight: "bold" }}>
                  Now
                </h5>
                <ul style={{ paddingLeft: "1.2rem", lineHeight: "1.8" }}>
                  <li>
                    Graduating from Tampere University (MSc in
                    Information Security, minor in Human-Technology
                    Interaction). <br/>
                    MSc thesis:{" "} <em>
                      “Cross-Platform Privacy Tool for Facebook: Architecture
                      and Implementation.”
                    </em>
                  </li>
                  <li>
                    Working part-time as a full-stack developer at Superwider
                    (Next.js / TypeScript).
                  </li>
                  <li>
                    Expanding and maintaining{" "}
                    <a
                      href="https://ibtehaz.xyz"
                      target="_blank"
                      rel="noreferrer"
                    >
                      ibtehaz.xyz
                    </a>{" "}
                    — my personal portfolio, blog, and playground.
                  </li>
                  <li>
                    Exploring calm tech, data storytelling, and XR prototyping.
                  </li>
                  <li>
                    Completing Asian Studies minor at the University of Turku.
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-6">
              {/* right */}

              {/* Image snapshot */}
              <div className="text-center mt-5">
                <img
                  src={ideas} // <- replace with your image
                  alt="A calm, moody, minimal workspace representing a focused and thoughtful environment"
                  style={{
                    maxWidth: "100%",
                    borderRadius: "10px",
                    boxShadow: "0 2px 10px rgba(20, 21, 20, 0.79)",
                  }}
                />
                <p
                  className="mt-2"
                  style={{ fontStyle: "italic", fontSize: "0.9rem" }}
                >
                  Not my desk, but it kind of feels like how my mind looks most
                  days.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GetToKnowMe;
